import { business } from '@icabbi/api-gateway-client';
import apiInstance from '@/helpers/apiInstance';

const defaultState = {
  apiClient: null,
};

const getters = {
  apiClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (!state.apiClient) {
      state.apiClient = apiInstance({
        dispatch,
        getters: rootGetters,
        Connector: business.PaxCoreConnector
      });
    }
    return state.apiClient;
  },
};


async function createEvents(context, { payload }) {
  const apiClient = context.getters.apiClient(context);
  await apiClient.createBusinessBookerEvents({
   payload,
  });
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions: {
    createEvents,
  },
};
